import { CONTENT_LANGUAGE_CODES } from '@/locales/supportedLocales.ts';
import { useAccountStore } from '@/store/modules/account/store.js';
import Enum from './Enum.js';

export default class Locale extends Enum {
    static get entries() {
        const contextAccount = useAccountStore().contextAccount;

        const locales = new Set(
            (contextAccount?.localization?.content_languages || [])
                .filter((locale) => locale.enabled !== false)
                .map((locale) => locale.code)
        );

        return Object.fromEntries(
            CONTENT_LANGUAGE_CODES.filter((locale) => locales.has(locale)).map((locale) => [
                locale,
                locale,
            ])
        );
    }

    static get FR() {
        return this.entries.fr;
    }

    static get EN() {
        return this.entries.en;
    }

    static get NL() {
        return this.entries.nl;
    }

    static get translationGroup() {
        return 'locales';
    }
}
